import { useGetProvider } from "@/hooks/providers";
import { useGetService } from "@/hooks/services";
import { createFileRoute, Link } from "@tanstack/react-router";
import { z } from "zod";
import { ServiceProvidersPage } from "./-components";

export const Route = createFileRoute(
  "/(service-providers)/service-providers/$id"
)({
  component: RouteComponent,
  validateSearch: z.object({
    domain: z.enum(["service", "provider"]),
  }),
});

function RouteComponent() {
  const { domain } = Route.useSearch();
  if (domain === "service") return <ServiceProvidersForService />;
  return <ServiceProvidersForProvider />;
}
//TODO update link
function ServiceProvidersForService() {
  const { id } = Route.useParams();
  const { data: service, isLoading } = useGetService(id);
  return (
    <ServiceProvidersPage
      domain="service"
      domainId={id}
      domainLoading={isLoading}
      domainName={service?.name}
      editLink={(spId, children, key) => (
        <Link
          key={key}
          to="/service-providers/$id/edit/$spId"
          params={{ id, spId }}
          search={{ domain: "service" }}
        >
          {children}
        </Link>
      )}
    />
  );
}
function ServiceProvidersForProvider() {
  const { id } = Route.useParams();
  const { data: provider, isLoading } = useGetProvider(id);
  return (
    <ServiceProvidersPage
      domain="provider"
      domainId={id}
      domainLoading={isLoading}
      domainName={provider?.name}
      editLink={(spId, children, key) => (
        <Link
          key={key}
          to="/service-providers/$id/edit/$spId"
          params={{ id, spId }}
          search={{ domain: "provider" }}
        >
          {children}
        </Link>
      )}
    />
  );
}
